import React, { useEffect, useState, useCallback } from "react";
import { Modal, Card } from "antd";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./ModalLoading.css";
import constants from "../constants/constants.json";
import Axios from "axios";
import { setUserInfo } from "../store/actions/user";
import Message from "../helper/Message";

export default function ModalLoading(props) {
  const { visibleModal, setVisibleModal } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(true);

  const getLogged = useCallback(async () => {
    setIsLoading(true);
    setIsFetched(true);
    try {
      const token = localStorage.getItem("pnsToken");
      let response = await Axios.get(constants.url + "/user/profile", {
        headers: {
          authorization: "Bearer " + token,
        },
      });
      
      if (response.data.status === 202) {
        dispatch(
          setUserInfo({
            personal: {
              name: response.data.result.user.name,
              id: response.data.result.user.id,
              email: response.data.result.user.mail,
              roleAdmin:response.data.result.user.roleAdmin
            },
          })
        );
        setIsLoading(false);
        setIsFetched(true);
        setVisibleModal(false);

      } else {
        Message.error(response.data.result.message);
        setIsLoading(false);
        setIsFetched(false);
        setVisibleModal(false);
        history.replace("/login")
      }
    } catch (err) {
        Message.error("Communication error");
        setIsLoading(false);
        setIsFetched(false)
        setVisibleModal(true)
    }
  },[]);
  useEffect(() => {
    getLogged();
  }, [getLogged]);

  return (
    <Modal
      wrapClassName="ModalLoading"
      bodyStyle={{ padding: 0 }}
      // centered
      // onCancel={() => setVisible(false)}
      // destroyOnClose={true}
      closable={false}
      footer={false}
      visible={visibleModal}
      zIndex={100}
      centered
      className="loading-modal"
    >
      <Card
        headStyle={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
        }}
        title="loading..."
      >
        <div className="modal-card-content">
          {isLoading ? (
            <Loading3QuartersOutlined spin style={{ fontSize: "30px" }} />
          ) : (
            !isFetched && (
              <div className="modal-loading-fail-contaier">
                <p className="modal-message">
                  Lack of communication with the server
                </p>
                <div onClick={getLogged} className="modal-reload-button">
                  <span className="modal-reload-button-font">Retry</span>
                </div>
              </div>
            )
          )}
        </div>
      </Card>
    </Modal>
  );
}
